
const CallType = Object.freeze({
    GET: 0,
    POST: 1,
  });

async function callBE(ctx, callType, path, params) {
    console.log("callBE");
    var response;
    if (callType === CallType.GET) {
        if (params) {
            throw new Error("GET callType does not support params");
        }
        response = await ctx.$http.get(ctx.$consts.BE_ADDRESS + path, {
            headers: {
                Authorization: ctx.$store.state.token,
            },
        });
    } else if (callType === CallType.POST) {
        response = await ctx.$http.post(ctx.$consts.BE_ADDRESS + path, 
            params,
            {
                headers: {
                    Authorization: ctx.$store.state.token,
                },
            }
        );
    } else {
        throw new Error("Invalid callType");
    }
    if (response.status === 200) {
        // console.log("callBE got 200. Returning response.data: " + JSON.stringify(response.data));
        return response.data;
    }
    console.log("callBE got non-200 but didn't throw");
    throw new Error("callBE unsuccessful error");
}

export default {
    trackEvent: function trackEvent(eventName, params) {
        if (typeof window.gtag === 'function') {
            window.gtag('event', eventName, params);
        }
    },
    // Resolves the GA4 client_id for the current browser, so a server-side event (e.g. a
    // purchase reported from a Stripe webhook) can be attributed to this session in GA. Resolves
    // to "" if gtag isn't available or doesn't respond in time (ad blocker, slow load, etc).
    getGaClientId: function getGaClientId() {
        return new Promise((resolve) => {
            if (typeof window.gtag !== 'function') {
                resolve("");
                return;
            }
            let resolved = false;
            const done = (clientId) => {
                if (resolved) return;
                resolved = true;
                resolve(clientId || "");
            };
            window.gtag('get', 'G-7KF4K76WWN', 'client_id', done);
            setTimeout(() => done(""), 1000);
        });
    },
    logoutIfNeeded: function logoutIfNeeded(ctx, error) {
        console.log("logoutIfNeeded()");
        console.log("burny! error?.response?.data?.BError: " + error?.response?.data?.BError)
        if (
            error?.response?.data?.BError?.includes("token validation error")
          ) {
            console.log("Token validation error - logging out!");
            ctx.$store.dispatch("logout");
            console.log("ctx.$route.path: " + ctx.$route.path);
            ctx.$router.push({ path: "/login", query: { msg: "sessionExpired", path: ctx.$route.path } });
          }
    },
    forceLogout: function forceLogout(ctx) {
        ctx.$store.dispatch("logout");
        ctx.$router.push({ path: "login"});
    },
    handleBackendError: function handleBackendError(ctx, error) {
        this.logoutIfNeeded(ctx, error);
        //this.handleKnownRespCodes(ctx, error);
        // todo: maybe inform BE that FE error ocurred
    },
    handleKnownRespCodes: function handleKnownRespCodes(ctx, error) {
        if (error?.response?.status) {
            var respCode = error.response.status;
            if (respCode == 403) {
                ctx.$router.push({ path: "403" });
            }
            else if (respCode == 404) {
                ctx.$router.push({ path: "404" });
            } else if (respCode == 503) {
                ctx.$router.push({ path: "503" });
            }
        }
    },
    redirectKnownRespCodes: function redirectKnownRespCodes(ctx, statusCode, backendError) {
        const path = "";
        if (statusCode == 403 || statusCode == 404 || statusCode == 503) {
            path = statusCode.toString();
            if (backendError) {
                ctx.$router.push({ path: path, query: { msg: backendError } });
                return;
            }
            ctx.$router.push({ path: path });
        }
    },
    getErrorMsg: function getErrorMsg(error) {
        console.log("getErrorMsg(): " + JSON.stringify(error))
        console.log("error.response: " + JSON.stringify(error.response))
        
        if (error) {
            if (error.response?.data?.BError) {
                return error.response.data.BError;
            }
            if (error.response?.data?.error) {
                return error.response.data.error;
            }
            if (error.message) {
                return error.message;
            }
        }
        return "Unknown error";
    },
    shortenRevId: function shortenRevId(revId) {
        const revIdStr = new String(revId);
        if (revId == null || revIdStr.split("-").length < 2 || revIdStr.split("-")[1].length < 8) {
            return "";
        }
        return revIdStr.split("-")[1].slice(0, 8).toUpperCase()
    },
     visit: async function visit(ctx) {
        try {
            await this.callBackendGet(ctx, `/pub/visit?dusi=${ctx.$store.getters.getDusi}&path=${ctx.$route.name}`);
        } catch (error) {
            console.log("utils.visit() error: " + error);
        }
    },
    callBackendGet: async function callBackendGet(ctx, path) {
        console.log(`callBackendGet(${path})`);
        try {
            return await callBE(ctx, CallType.GET, path, null);
        } catch (error) {
            console.log("callBE caught error: " + JSON.stringify(error));
            this.logoutIfNeeded(ctx, error);
            var backendError = error?.response?.data?.BError;
            this.redirectKnownRespCodes(ctx, error.status, backendError);
            if (backendError) {
                console.log("callBE got BError: " + backendError);
                throw new Error(backendError);
            }
            // unexpected stuff - FE error
            // todo: report to BE
            throw new Error("Unexpected FE error: " + error);
        }
    },
    callBackendPost: async function callBackendPost(ctx, path, params) {
        console.log(`callBackendPost(${path}, ${JSON.stringify(params)})`);
        try {
            return await callBE(ctx, CallType.POST, path, {dusi: ctx.$store.getters.getDusi, ...params});
        } catch (error) {
            console.log("callBE caught error:" + JSON.stringify(error));
            this.logoutIfNeeded(ctx, error);
            var backendError = error?.response?.data?.BError;
            this.redirectKnownRespCodes(ctx, error.status, backendError);
            if (backendError) {
                console.log("callBE got BError: " + backendError);
                throw new Error(backendError);
            }
            if (error.message.includes("Network Error")) {
                console.log("Network error: " + JSON.stringify(error));
                throw new Error("Network error");
            }
            
            // unexpected stuff - FE error
            // todo: report to BE
            throw new Error("Unexpected FE error: " + error);
        }
    },
    // sends FE error to BE (does not throw on error)
    reportFError: async function reportFError(ctx, errorMessage) {
        try {
            return await callBE(ctx, CallType.POST, "/pub/reportFError", {dusi: ctx.$store.getters.getDusi, errorMsg: JSON.stringify(errorMessage)});
        } catch (error) {
            console.log("reportFError caught error:" + JSON.stringify(error));
        }
    },
    timeFromTs: function timeFromTs(ts) {
        if (ts == null || ts == 0) {
            return "";
        }
        const date = new Date(ts);
        return date.toLocaleTimeString() + " " + date.toLocaleDateString();
    },
    detailedTimeFromTs: function detailedTimeFromTs(ts) {
        if (ts == null || ts == 0) {
            return "";
        }
        const date = new Date(ts);
        return date.toLocaleString("en-US", {
            timeZoneName: "short",
        });
    },
    tsMsFromDetailedTime: function tsMsFromDetailedTime(detailedTime) {
        return Date.parse(detailedTime);
    },
    relativeTimeFromTs: function relativeTimeFromTs(ts) {
        if (ts == null || ts == 0) {
            return "";
        }
        const now = new Date();
        const diff = now.getTime() - ts;
        if (diff < 60000) {
            return "just now";
        }
        if (diff < 3600000) {
            var val = Math.floor(diff / 60000)
            return `${val} minute${val === 1 ? '' : 's'} ago`
        }
        if (diff < 86400000) {
            var val = Math.floor(diff / 3600000)
            return `${val} hour${val === 1 ? '' : 's'} ago`
        }
        if (diff < 604800000) {
            var val = Math.floor(diff / 86400000)
            return `${val} day${val === 1 ? '' : 's'} ago`
        }
        if (diff < 2592000000) {
            var val = Math.floor(diff / 604800000)
            return `${val} week${val === 1 ? '' : 's'} ago`
        }
        if (diff < 31536000000) {
            var val = Math.floor(diff / 2592000000)
            return `${val} month${val === 1 ? '' : 's'} ago`
        }
        var val = Math.floor(diff / 31536000000)
        return `${val} year${val === 1 ? '' : 's'} ago`
    }
}